function Om() {
	return <h1>Om sir</h1>;
  };
  
  export default Om;